import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./VipClubFaq.css";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { RiArrowDownSLine } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";



const VipClubFaq = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: "How does a Betbazaar365 work?",
            answer: "Betbazaar365 operates on BSC blockchain. It enables users to engage in transactions directly with one another as opposed to relying on a central authority."
        },
        {
            question: "What is fair game in casino?",
            answer: "The game is said to be 'fair' if it allows all players to have strictly the same chance of winning or losing. In other words, the same probabilities apply to every game played."
        },
        {
            question: "How do you play Provably fair?",
            answer: "The gambling site creates a seed number which is then hashed and sent to the player."
        },
        {
            question: "How to deposit?",
            answer: "After login with Metamask or any web3 wallet, go to Wallet > Choose deposit amount > Confirm Metamask sign and finish."
        },
        {
            question: "How long does it take to deposit and withdraw?",
            answer: "Deposits/Withdraws from BSC happen using a state sync mechanism and take about 3-7 minutes. If you encounter any problem, visit www.bscscan.com to check your transaction."
        },
        {
            question: "How INR deposit works?",
            answer: "Betbazaar365 offers various options for INR deposits. Users can deposit manually with UPI, QR Code, or Payment Gateways like Netbanking, UPI, PhonePe, Google Pay, Paytm, or Cards. Deposits may take 1 to 2 hours depending on user volume."
        }
    ];

    // Toggle active question
    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <>
            <Helmet>
                <title>Faq</title>
               
                <link rel="canonical" href="/faq" />
            </Helmet>

            <div className="faq-main-conatiner">
                <div className="faq-heading-conatiner">
                    <p>Frequently Asked Questions</p>
                </div>
                <div className="faq-questions-conatiner">
                    {faqData.map((item, index) => (
                        <div  key={index}>
                            <h4
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                                style={{ cursor: "pointer" }}
                            >
                                {item.question}
                                <span className="faq-icon">
                                    {activeIndex === index ? (
                                       <RiArrowDownSLine/>  
                                    ) : (
                                        <MdKeyboardArrowRight />
                                    )}
                                </span>
                            </h4>
                            {activeIndex === index && (
                                <p className="faq-answer">{item.answer}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default VipClubFaq;